import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "asset-bidders" }
const _hoisted_2 = { class: "asset-bidders__header" }
const _hoisted_3 = { class: "asset-bidders__content" }
const _hoisted_4 = {
  key: 0,
  class: "asset-bidders__item--first"
}
const _hoisted_5 = { class: "asset-bidders__item--second" }
const _hoisted_6 = { class: "asset-bidders__item--third" }
const _hoisted_7 = {
  key: 0,
  class: "asset-bidders__empty"
}

import { computed } from 'vue';

// #interfaces
interface IBidder {
  rank: string | number;
  name: string;
  price: string | number;
}
interface IProps {
  currency: string;
  bidders: IBidder[];
  getHeadersToRendering: { name: string; value: string };
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewBidders',
  props: {
    currency: { default: '' },
    bidders: { default: () => [] },
    getHeadersToRendering: {}
  },
  setup(__props: any) {

const props = __props;

// #methods
const formatCurrency = (value: number | string): string => {
  if (!value) return '';
  const currency = props.currency;

  // Check if `value` is a string, if so, parse it into a number
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0
  }).format(numericValue);
};

// #computed
const getHeadersToRenderingValue = computed(() => {
  const { value } = props.getHeadersToRendering ?? {};
  return value;
});
const getHeadersToRenderingName = computed(() => {
  const { name } = props.getHeadersToRendering ?? {};
  return name;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(getHeadersToRenderingName.value), 1),
        _createElementVNode("div", null, _toDisplayString(getHeadersToRenderingValue.value), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bidders, (bidder, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass(["asset-bidders__item", 
            getHeadersToRenderingName.value !== 'Rank' &&
            'asset-bidders__item--without-rank'
          ])
          }, [
            (getHeadersToRenderingName.value === 'Rank')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(bidder.rank), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, _toDisplayString(bidder.name), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(formatCurrency(bidder.price)), 1)
          ], 2))
        }), 128)),
        (!__props.bidders.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " There are no bidders yet "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})